import { IdDescription } from '../../../tms-shared';

export interface ProductForSalesOrderLine {
  productId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  productShortDescription: string;
  supplierDescription: string;
  customerDescription: string;
  productComments: string;
  productTypeId: string;
  productTypeDescription: string;
  makeUp: string;
  stdPrice: number;
  stdCutPrice: number;
  unitOfMeasureId: string;
  unitOfMeasure: string;
  dateCreated: Date;
  createdBy: string;
  lastUpdatedDate: Date;
  lastUpdatedBy: string;
  conversionUomId: string;
  conversionQuantity: number;
  conversionUnit: string;
  makeUpId: string;
  orderUnitOfMeasureId: string;
  orderUnitOfMeasureDescription: string;
  orderUnitOfMeasureShortDescription: string;
  priceListUnitOfMeasureId: string;
  priceListUnitOfMeasureDescription: string;
  priceListUnitOfMeasureShortDescription: string;
  clearanceProduct: string;
  inlineAllocation: boolean;
  cutPrice: boolean;
  currencyCode: string;
  standardRollLength: number;
  holdStockAtProductLevel: boolean;
  showNoOfItems: boolean;
  availableStock: number;
  customerId: string;
  customerKey: string;
  customerName: string;
  notes: string;
  nextDayDelivery: boolean;
  discountRate: number;
  bomProduct: string;
  availableProductId: string;
  wrongSellingCompany: boolean;
  returnableProduct: boolean;
  minimumOrderQuantity: number;

  availableProductIds: IdDescription[];
}
